import { TextShow } from 'Utils/Helpers/TextShow';
import * as icons from 'react-bootstrap-icons';
import Header from '../Header';
import Checkbox from '@mui/material/Checkbox';
import { FormControlLabel } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';
import { updateMessage } from 'http/components/SettingService';
import { HandleLoading } from 'Utils/Helpers/HandleLoading';
import { enqueueSnackbar } from 'notistack';

const title = 'پیام‌رسان';

export default function SetMessageSettings() {
  const dispatch = useDispatch();
  const { clinic, message, wallet } = useSelector((state) => ({
    clinic: state.user.clinic,
    message: state.setting.message,
    wallet: state.setting.wallet,
  }));
  const [controls, setControls] = useState([]);

  useEffect(() => {
    if(clinic && message) {
      setControls(message);
    }
  },[clinic, message])

  const handleChange = (id) => {
    setControls(controls.map(i => {
      if(i.name === id) return {...i, value: !i.value,}
      else return {...i}
    }));
  }

  const onFinish = async () => {
    if(controls) {
      const _arr = controls.map((item, index) => {
        return {
          ...item,
          cost: 360,
          exp: message[index].exp
        }
      })
      dispatch(HandleLoading(true));
      const response = await updateMessage(_arr);
      if(response.status) {
        dispatch(HandleLoading(false));
        enqueueSnackbar('تنظیمات پیام‌رسان با موفقیت ذخیره شد', {variant: 'success'});
      }
    } else {
      enqueueSnackbar('اطلاعات به درستی بارگذاری نشده اند، لطفا صفحه خود را بروزرسانی کنید', {variant: 'error'});
    }
  }

  function CheckBox ({ key, id, value, label, exp, cost}) {
    return (
      <div className='message-box'>
        <div className='title'>
          <p>{label}</p>
        </div>
        <div className='rows-details'>
          <span>وضعیت</span>
          <FormControlLabel
            key={key}
            control={<Checkbox checked={value} id={id} onChange={() => handleChange(id)} />}
            label={'فعال'}
          />
        </div>
        <div className='rows-details'>
          <span>متن پیام</span>
          <small>{exp}</small>
        </div>
        <div className='rows-details'>
          <span>هزینه پیام</span>
          <small>{`${cost} تومان`}</small>
        </div>
      </div>
    )
  }

  return (
    <>
      {
        controls &&
        <>
          <Header title={title} justText={controls.length === 0} onClick={onFinish} />
          <div className='mt-4'>
            <TextShow
              title={"تنظیم پیام رسان"}
              icon={<icons.ChatLeft size={18} />}
              justText
              className={'no-hide text-muted'}
              exp={"تنظیم پیام‌هایی که از طریق پیام‌رسان برای بیماران خواهد رفت"}
              className3={'text-danger'}
              breaksm
            />
            <div className='setting-messages'>
              <div className='details'>
                {
                    controls.length !== 0
                    ? <>
                      <div className='wallet'>
                        <div>
                          <span>{"موجودی کیف پول :"}</span>
                          <span>{`${wallet.toLocaleString()} تومان`}</span>
                        </div>
                      </div>
                      {
                        controls.map(items => {
                          return (
                            <CheckBox
                              key={`message_checked_${items.name}`}
                              id={items.name}
                              value={items.value}
                              label={items.label}
                              exp={items.exp}
                              cost={items.cost}
                            />
                          )
                        })
                      }
                    </>
                    : <div className='mt-2 flex-column-center-start'>
                        <div>
                          <icons.ExclamationDiamond className='ms-2' color='gray'/>
                          <small>{'پیام‌رسان شما فعال نمی‌باشد، برای فعال سازی با شماره‌های پشتیبانی تماس حاصل فرمایید'}</small>
                        </div>
                      </div>
                }
              </div>
            </div>
          </div>
        </>
      }
    </>
  );
}